<template lang='pug'>
//- Setting-Page
div(:class='$style[`cc-setting`]')
  div(v-if='!isPreloading' :class='$style[`cc-setting-banner`]')
    div(:class='$style[`cc-banner-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.no-wrap 帳戶
        span.font-doctor-theme 設
        span.font-normal-theme 定

      //- 大頭照
      button(
        v-if='loginProfile.user_type === `doctor`'
        tabindex='0'
        aria-label='上傳頭像'
        :class='$style[`cc-banner-avatar`]'
        @click='showAvatarUploader')
        div(:class='$style[`cc-avatar-upload`]')
          IconCamera(:size='14' :color='`#fff`')
          span 上傳頭像

        figure(v-if='loginProfile.thumbSrc === ``' :class='$style[`cc-avatar-photo`]')
          //- Doctor-Male-Avatar
          img(
            v-if='loginProfile.gender === `0`'
            :src='`${STATIC_URL}images/common/user/doctor_male.webp`'
            width='100%'
            height='100%')
          //- Doctor-Female-Avatar
          img(
            v-else
            :src='`${STATIC_URL}images/common/user/doctor_female.webp`'
            width='100%'
            height='100%')

        figure(v-else :class='$style[`cc-avatar-photo`]')
          img(
            :src='avatarSrcLink(loginProfile.thumbSrc)'
            width='100%'
            height='100%')

      //- 大頭照
      //- div(
      //-   v-else-if='loginProfile.user_type === `doctor`'
      //-   :class='$style[`cc-banner-avatar`]')
      //-   figure(v-if='loginProfile.thumbSrc === ``' :class='$style[`cc-avatar-photo`]')
      //-     //- Doctor-Male-Avatar
      //-     img(
      //-       v-if='loginProfile.gender === `0`'
      //-       :src='`${STATIC_URL}images/common/user/doctor_male.webp`'
      //-       width='100%'
      //-       height='100%')
      //-     //- Doctor-Female-Avatar
      //-     img(
      //-       v-else
      //-       :src='`${STATIC_URL}images/common/user/doctor_female.webp`'
      //-       width='100%'
      //-       height='100%')

      //-   figure(v-else :class='$style[`cc-avatar-photo`]')
      //-     img(
      //-       :src='avatarSrcLink(loginProfile.thumbSrc)'
      //-       width='100%'
      //-       height='100%')

      //- 大頭照
      button(
        v-else-if='loginProfile.user_type === `normal` && loginProfile.account_login === `cancell`'
        tabindex='0'
        aria-label='上傳頭像'
        :class='$style[`cc-banner-avatar`]'
        @click='showAvatarUploader')
        div(:class='$style[`cc-avatar-upload`]')
          IconCamera(:size='14' :color='`#fff`')
          span 上傳頭像

        figure(v-if='loginProfile.thumbSrc !== `` && loginProfile.public' :class='$style[`cc-avatar-photo`]')
          img(
            :src='avatarSrcLink(loginProfile.thumbSrc)'
            width='100%'
            height='100%')

        figure(v-else :class='$style[`cc-avatar-photo`]')
          img(
            v-if='loginProfile.gender === `0`'
            :src='`${STATIC_URL}images/common/user/normal_male.webp`'
            width='100%'
            height='100%')
          img(
            v-else
            :src='`${STATIC_URL}images/common/user/normal_female.webp`'
            width='100%'
            height='100%')


      //- 大頭照
      div(
        v-else-if='loginProfile.user_type === `normal` && loginProfile.account_login !== `cancell`'
        :class='$style[`cc-banner-avatar`]')
        figure(v-if='loginProfile.thumbSrc !== `` && loginProfile.public' :class='$style[`cc-avatar-photo`]')
          img(
            :src='avatarSrcLink(loginProfile.thumbSrc)'
            width='100%'
            height='100%')

        figure(v-else :class='$style[`cc-avatar-photo`]')
          img(
            v-if='loginProfile.gender === `0`'
            :src='`${STATIC_URL}images/common/user/normal_male.webp`'
            width='100%'
            height='100%')
          img(
            v-else
            :src='`${STATIC_URL}images/common/user/normal_female.webp`'
            width='100%'
            height='100%')
     


      div(v-if='loginProfile.user_type === `doctor`' :class='$style[`cc-avatar-name`]')
        span.font-bold.font-doctor-theme {{ `${avatarShowName}` }}
        //- span.font-bold!= '醫師'

      div(v-else :class='$style[`cc-avatar-name`]')
        span.font-bold.font-normal-theme(v-if='loginProfile.public === `yes`') {{ `${avatarShowName}` }}
        span.font-bold.font-normal-theme(v-else) {{ loginProfile.gender === `0` ? `${loginProfile.firstName}先生` : `${loginProfile.firstName}小姐` }}
        span.font-bold!= '會員'

      //- div(v-else :class='$style[`cc-avatar-name`]')
        //- span.font-bold!= '無效的會員'

    div(v-if='loginProfile.user_type === `normal`' :class='$style[`cc-setting-menu`]')
      div(:class='$style[`cc-setting-menu-wrap`]')
        router-link(
          exact=true
          role='button'
          tabindex='0'
          aria-label='查看個人檔案'
          :class='$style[`cc-menu-nav`]'
          :active-class='$style[`js-selected`]'
          to='/ecard')
          IconData(:size='21' :color='`#262626`')
          span 病歷資料
          
        router-link(
          exact=true
          role='button'
          tabindex='0'
          aria-label='查看個人檔案'
          :class='$style[`cc-menu-nav`]'
          :active-class='$style[`js-selected`]'
          to='/setting')
          IconSetting(:size='21' :color='`#262626`')
          span 帳戶設定


    //- 個人資料清單
    div(:class='$style[`cc-setting-profile`]')
      ul(:class='$style[`cc-profile-content`]')
        //- 會員等級
        li(:class='[$style[`cc-profile-list`], $style[`flex-row`]]')
          div(:class='$style[`cc-profile-list-title`]')
            span(:class='$style[`cc-profile-list-title-text`]') 會員等級
          div(:class='[$style[`cc-profile-list-value`], $style[`cc-profile-list-vip`]]')
            div(
              v-if='subscribeVip === `yes`'
              :class='$style[`cc-profile-vip-status`]')
              span.border-gradient(:class='$style[`cc-profile-vip-status-vip`]') VIP會員
              span(:class='$style[`cc-profile-vip-status-valid`]') {{ loginSubscribeValid[0].dueTime }} 到期
            div(
              v-else
              :class='$style[`cc-profile-vip-status`]')
              span(:class='$style[`cc-profile-vip-status-free`]') 基本會員

        
        //- 帳號狀態
        li(:class='$style[`cc-profile-list`]')
          div(:class='$style[`cc-profile-list-title`]')
            span(:class='$style[`cc-profile-list-title-text`]') 帳號狀態
            router-link(
              role='button'
              tabindex='0'
              aria-label='帳號狀態'
              to='/tutorial#hide'
              :class='[$style[`cc-profile-list-tip`], $style[`cc-profile-list-tip-public`]]')
              IconInfo(:size='22' :color='`#dfe1e5`')


          div(:class='[$style[`cc-profile-list-value`], $style[`cc-profile-list-public`]]')
            Select(
              v-if='loginProfile.user_type === `doctor`'
              title='帳號狀態'
              v-model='accountProfile.public'
              :isDisabled='true'
              :defaultValue='`公開`'
              :class='$style[`cc-input-public`]'
              :placehold='`選擇狀態`'
              :optionList='[`公開`, `匿名`]'
              @sendSelectValue='setPublicSelectValue'
              @clearErrorMsg="(value) => {this.checkEmptyStatus.public = value}")

            Select(
              v-else
              title='帳號狀態'
              v-model='accountProfile.public'
              :defaultValue='loginProfile.public === `yes` ? `公開` : `匿名`'
              :class='$style[`cc-input-public`]'
              :placehold='`選擇狀態`'
              :optionList='[`公開`, `匿名`]'
              @sendSelectValue='setPublicSelectValue'
              @clearErrorMsg="(value) => {this.checkEmptyStatus.public = value}")

            router-link(
              role='button'
              tabindex='0'
              aria-label='帳號狀態'
              to='/tutorial#hide'
              :class='[$style[`cc-profile-list-tip`], $style[`cc-profile-list-tip-public`]]')
              IconInfo(:size='22' :color='`#dfe1e5`')



        //- 登入帳號
        li(v-if='loginProfile.account_login === `cancell`' :class='$style[`cc-profile-list`]')
          div(:class='$style[`cc-profile-list-title`]')
            span(:class='$style[`cc-profile-list-title-text`]') 登入帳號

          div(:class='[$style[`cc-profile-list-value`], $style[`cc-profile-list-email`]]')
            i(:class='$style[`cc-input-tips`]') * 更新後需要重新登入
            Inputer(
              title='已使用手機登入'
              v-model.trim='accountProfile.account'
              :defaultValue='loginProfile.oauth'
              :class='$style[`cc-input-email`]'
              :resetButton='false'
              :placehold='`手機 / 信箱`'
              :errorRegex='checkEmptyStatus.accountRegexError'
              :errorRegexInfo='checkEmptyStatus.accountErrorLog'
              :errorValue='checkEmptyStatus.accountError'
              @clearErrorMsg="(value) => {this.checkEmptyStatus.accountError = value[0]; this.checkEmptyStatus.accountRegexError = value[1];}")

            //- Inputer(
            //-   v-if='!loginProfile.phone && loginProfile.email'
            //-   title='已使用信箱登入'
            //-   v-model.trim='accountProfile.account'
            //-   :defaultValue='loginProfile.email'
            //-   :class='$style[`cc-input-email`]'
            //-   :resetButton='false'
            //-   :placehold='`手機 / 信箱`'
            //-   :errorRegex='checkEmptyStatus.accountRegexError'
            //-   :errorRegexInfo='checkEmptyStatus.accountErrorLog'
            //-   :errorValue='checkEmptyStatus.accountError'
            //-   @clearErrorMsg="(value) => {this.checkEmptyStatus.accountError = value[0]; this.checkEmptyStatus.accountRegexError = value[1];}")



        //- 登入帳號
        li(v-if='loginProfile.account_login === `cancell`' :class='$style[`cc-profile-list`]')
          div(:class='$style[`cc-profile-list-title`]')
            span(:class='$style[`cc-profile-list-title-text`]') 我的信箱

          div(:class='[$style[`cc-profile-list-value`], $style[`cc-profile-list-email`]]')
            i(:class='$style[`cc-input-tips`]') * 接收通知用途 (如果登入帳號為信箱，須同步)
            Inputer(
              title='接收通知的信箱'
              v-model.trim='accountProfile.email'
              :defaultValue='loginProfile.email'
              :class='$style[`cc-input-email`]'
              :resetButton='false'
              :placehold='`mail@gmail.com`'
              :errorRegex='checkEmptyStatus.emailRegexError'
              :errorRegexInfo='checkEmptyStatus.emailErrorLog'
              :errorValue='checkEmptyStatus.emailError'
              @clearErrorMsg="(value) => {this.checkEmptyStatus.emailError = value[0]; this.checkEmptyStatus.emailRegexError = value[1];}")


        //- 電子信箱
        //- li(:class='$style[`cc-profile-list`]')
        //-   div(:class='$style[`cc-profile-list-title`]')
        //-     span(:class='$style[`cc-profile-list-title-text`]') 電子信箱
        //-     div(
        //-       :class='[$style[`cc-profile-list-tip`], $style[`cc-profile-list-tip-email`]]'
        //-       @click="() => {this.showPublicTip = false; this.showEmailTip = !this.showEmailTip}")
        //-       transition(name='ani-slide-up-fade' mode='out-in')
        //-         span(v-show='showEmailTip' :class='$style[`cc-profile-list-tip-info`]')!= '目前信箱修改功能開發中。敬請期待!'
        //-       IconInfo(:size='22' :color='this.showEmailTip ? `#b1b1b1` : `#dfe1e5`')
        //-   div(:class='[$style[`cc-profile-list-value`], $style[`cc-profile-list-email`]]')
        //-     Inputer(
        //-       title='電子信箱'
        //-       v-model.trim='accountProfile.email'
        //-       :defaultValue='loginProfile.email'
        //-       :class='$style[`cc-input-email`]'
        //-       :resetButton='false'
        //-       :placehold='`信箱`'
        //-       :errorRegex='checkEmptyStatus.emailRegexError'
        //-       :errorRegexInfo='checkEmptyStatus.emailErrorLog'
        //-       :errorValue='checkEmptyStatus.emailError'
        //-       @clearErrorMsg="(value) => {this.checkEmptyStatus.emailError = value[0]; this.checkEmptyStatus.emailRegexError = value[1];}")

        //-     button.btn-extra(:class='[$style[`cc-profile-list-edit`], $style[`cc-profile-list-tip-email`]]')
        //-       IconEdit(:size='26' :color='`#6f6f6f`')

        //-     div(
        //-       :class='[$style[`cc-profile-list-tip`], $style[`cc-profile-list-tip-email`]]'
        //-       @click="() => {this.showPublicTip = false; this.showEmailTip = !this.showEmailTip}")
        //-       transition(name='ani-slide-up-fade' mode='out-in')
        //-         span(v-show='showEmailTip' :class='$style[`cc-profile-list-tip-info`]')!= '安全考量，信箱暫不開放修改'
        //-       IconInfo(:size='22' :color='this.showEmailTip ? `#b1b1b1` : `#dfe1e5`')


        //- 密碼
        li(v-if='loginProfile.account_login === `cancell`' :class='$style[`cc-profile-list`]')
          div(:class='$style[`cc-profile-list-title`]')
            span(:class='$style[`cc-profile-list-title-text`]') 會員密碼
          div(:class='[$style[`cc-profile-list-value`], $style[`cc-profile-list-pass`]]')
            span(:class='$style[`cc-profile-list-text`]') 安全考量不顯示
            //- button.btn-extra(:class='$style[`cc-profile-list-find-pass`]') 找回密碼
            button(
              :class='[$style[`cc-profile-find-pass`], $style[accountProfile.user_type === `doctor` ? `verify-doctor` : `verify-normal`]]' @click='sendFindPassword')!= '找回密碼'

        li(v-else :class='$style[`cc-profile-list`]')
          div(:class='$style[`cc-profile-list-title`]')
            span(:class='$style[`cc-profile-list-title-text`]') 登入方式
          div(:class='[$style[`cc-profile-list-value`], $style[`cc-profile-list-pass`]]')
            IconLine(:size='30')
            span(:class='$style[`cc-profile-list-text`]' style='padding-left: 5px') 快速登入


        //- 帳號驗證
        li(:class='$style[`cc-profile-list`]')
          div(:class='$style[`cc-profile-list-title`]')
            span(:class='$style[`cc-profile-list-title-text`]') 帳號驗證
          div(:class='[$style[`cc-profile-list-value`], $style[`cc-profile-list-verify`]]')
            div(
              v-if='accountProfile.verified === `yes`'
              :class='[$style[`cc-profile-verify-status`], $style[`cc-is-verify`]]')
              div(:class='$style[`cc-profile-verify-icon`]')
                IconConfirm(:size='16' :color='`#fff`')
              span!= '已認證'
            div(v-else :class='$style[`cc-profile-verify-status`]')
              div(:class='$style[`cc-profile-verify-icon`]')
                IconConfirm(:size='16' :color='`#fff`')
              span!= '未認證'
              div(
                :class='[$style[`cc-profile-verify-send`], $style[accountProfile.user_type === `doctor` ? `verify-doctor` : `verify-normal`]]'
                @click='sendVerifiedEmail') 驗證帳號


        //- 真實姓名
        li(:class='$style[`cc-profile-list`]')
          div(:class='$style[`cc-profile-list-title`]')
            span(:class='$style[`cc-profile-list-title-text`]') 真實姓名
          div(:class='[$style[`cc-profile-list-value`], $style[`cc-profile-list-name`]]')
            Inputer(
              title='姓氏'
              v-model.trim='accountProfile.firstName'
              :defaultValue='loginProfile.firstName'
              :class='$style[`cc-input-firstname`]'
              :resetButton='false'
              :placehold='`姓氏`'
              :errorValue='checkEmptyStatus.firstNameError'
              :errorRegex='checkEmptyStatus.firstNameRegexError'
              :errorRegexInfo='checkEmptyStatus.firstNameErrorLog'
              @clearErrorMsg="(value) => {this.checkEmptyStatus.firstNameError = value[0]; this.checkEmptyStatus.firstNameRegexError = value[1];}")

            Inputer(
              title='名字'
              v-model='accountProfile.lastName'
              :defaultValue='loginProfile.lastName'
              :class='$style[`cc-input-lastname`]'
              :resetButton='false'
              :placehold='`名字`'
              :errorValue='checkEmptyStatus.lastNameError'
              :errorRegex='checkEmptyStatus.lastNameRegexError'
              :errorRegexInfo='checkEmptyStatus.lastNameErrorLog'
              @clearErrorMsg="(value) => {this.checkEmptyStatus.lastNameError = value[0]; this.checkEmptyStatus.lastNameRegexError = value[1];}")

        //- 性別
        li(:class='$style[`cc-profile-list`]')
          div(:class='$style[`cc-profile-list-title`]')
            span(:class='$style[`cc-profile-list-title-text`]') 性別
          div(:class='[$style[`cc-profile-list-value`], $style[`cc-profile-list-gender`]]')
            Select(
              title='性別'
              v-model='accountProfile.gender'
              :defaultValue='loginProfile.gender === `0` ? `先生` : `小姐`'
              :class='$style[`cc-input-public`]'
              :placehold='`選擇性別`'
              :optionList='[`先生`, `小姐`]'
              :errorValue='checkEmptyStatus.genderError'
              @sendSelectValue='setGenderSelectValue'
              @clearErrorMsg="(value) => {this.checkEmptyStatus.genderError = value}")


        //- 主治癌症
        li(v-if='accountProfile.user_type === `doctor`' :class='$style[`cc-profile-list`]')
          div(:class='$style[`cc-profile-list-title`]')
            span(:class='$style[`cc-profile-list-title-text`]') 主治癌症
          div(:class='[$style[`cc-profile-list-value`], $style[`cc-profile-list-profession`]]')
            Select(
              v-model='accountProfile.profession'
              title='主治的癌症類型'
              :defaultValue='loginProfile.profession'
              :class='[$style[`cc-input-profession`], $style[otherProfessionShow ? `cc-half-width` : ``]]'
              :placehold='`選擇類型`'
              :optionList='CANCER_TYPE'
              :errorValue='checkEmptyStatus.professionError'
              @sendSelectValue='setProfessionSelectValue'
              @clearErrorMsg="(value) => {this.checkEmptyStatus.professionError = value}")

            Inputer(
              v-if='otherProfessionShow'
              v-model='accountProfile.profession'
              title='填寫完整癌症全名'
              style='margin-left: 10px;'
              :defaultValue='``'
              :class='[$style[`cc-input-profession`], $style[otherProfessionShow ? `cc-half-width` : ``]]'
              :resetButton='false'
              :placehold='`範例:某某癌`'
              :errorValue='checkEmptyStatus.professionError'
              @sendSelectValue='setProfessionSelectValue'
              @clearErrorMsg="(value) => {this.checkEmptyStatus.professionError = value[0];}")

        //- 醫護身份
        li(v-if='accountProfile.user_type === `doctor`' :class='$style[`cc-profile-list`]')
          div(:class='$style[`cc-profile-list-title`]')
            span(:class='$style[`cc-profile-list-title-text`]') 醫護身份
          div(:class='[$style[`cc-profile-list-value`], $style[`cc-profile-list-character`]]')
            Select(
              title='醫護身份'
              v-model='accountProfile.character'
              :defaultValue='loginProfile.character'
              :class='$style[`cc-input-public`]'
              :placehold='`選擇身份`'
              :optionList='[`主治醫師`, `護理師`, `個管師`, `營養師`, `物理治療師`, `職能治療師`, `語言治療師`, `藥劑師`, `心理師`, `社工師`]'
              :errorValue='checkEmptyStatus.characterError'
              @sendSelectValue='setCharacterSelectValue'
              @clearErrorMsg="(value) => {this.checkEmptyStatus.characterError = value}")

        //- 服務醫院
        li(v-if='accountProfile.user_type === `doctor`' :class='$style[`cc-profile-list`]')
          div(:class='$style[`cc-profile-list-title`]')
            span(:class='$style[`cc-profile-list-title-text`]') 服務醫院
          div(:class='[$style[`cc-profile-list-value`], $style[`cc-profile-list-hospital`]]')
            Inputer(
              title='服務的醫院'
              v-model='accountProfile.hospital'
              :defaultValue='loginProfile.hospital'
              :class='$style[`cc-input-hospital`]'
              :resetButton='false'
              :placehold='`醫院名稱`')

        //- 個人網站
        li(v-if='accountProfile.user_type === `doctor`' :class='$style[`cc-profile-list`]')
          div(:class='$style[`cc-profile-list-title`]')
            span(:class='$style[`cc-profile-list-title-text`]') 個人網站
          div(:class='[$style[`cc-profile-list-value`], $style[`cc-profile-list-introduction`]]')
            Inputer(
              title='個人網站'
              v-model.trim='accountProfile.introduction'
              :defaultValue='loginProfile.introduction'
              :class='$style[`cc-input-introduction`]'
              :resetButton='false'
              :placehold='`完整網站網址`')

      div(:class='$style[`cc-profile-controller`]')
        router-link.btn-black-extra(
          tag='button'
          tabindex='0'
          aria-label='預覽檔案'
          :class='[$style[`cc-control-button`], $style[`cc-control-update`]]'
          :to='{ name: `profile-detail`, params: { type: loginProfile.user_type, id: `${loginDjangoId}` }}') 預覽檔案

        button(
          tabindex='0'
          aria-label='立即更新'
          :class='[$style[`cc-control-button`], $style[`cc-control-update`], accountProfile.user_type === `doctor` ? `bg-doctor-theme` : `bg-normal-theme`]'
          @click='startCheckAndUpdateProcess') 立即更新


  div(v-if='isPreloading' :class='$style[`cc-preloader-content`]')
    div(:class='$style[`cc-banner-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.no-wrap 帳戶
        span.font-doctor-theme 設
        span.font-normal-theme 定

    div(:class='$style[`cc-preloader-banner`]')
      div.skeleton-preload(:class='$style[`cc-preloader-avatar`]')
      div(:class='$style[`cc-preloader-title`]')
        div.skeleton-preload(:class='$style[`cc-preloader-name`]')
        div.skeleton-preload(:class='$style[`cc-preloader-sub-title`]')


</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import GlobalEmitter from 'tiny-emitter/instance';

import { 
  // getSendVerifiedMail,
  getDjangoAllTypeMember,
  putUniqueDoctor,
  putUniqueNormal,
  putEditUserAccount,
  deleteSessionKeepLogin,
} from '../../../js/restapi';

import IconConfirm from '../../icon/Confirm';
import IconInfo from '../../icon/Info';
import IconCamera from '../../icon/Camera';
import IconEdit from '../../icon/Edit';
import Inputer from '../common/Input';
import Select from '../common/Select';
import IconLine from '../../icon/Line';
import IconData from '../../icon/Data';
import IconSetting from '../../icon/Setting';

export default {
  metaInfo() {
    return {
      title: '我的帳戶設定',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/setting',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/setting',
      }],
    };
  },

  components: {
    IconInfo,
    IconConfirm,
    IconCamera,
    IconLine,
    IconEdit,
    IconData,
    IconSetting,
    Inputer,
    Select,
  },

  data() {
    return {
      showPublicTip: false,
      showEmailTip: false,

      accountType: '',
      isAccountChange: false,

      isPreloading: true,
      avatarShowName: '',
      otherProfessionShow: false,

      accountProfile: {
        email: null,
        user_type: null,
        gender: null,
        public: null,
        thumbSrc:null,
        firstName: null,
        lastName: null,
        account: null,
        verified: null,
        profession: null,
        hospital: null,
        character: null,
        introduction: null,
      },

      checkEmptyStatus: {
        accountError: false,
        accountRegexError: false,
        accountErrorLog: '',

        emailError: false,
        emailRegexError: false,
        emailErrorLog: '格式錯誤',

        firstNameError: false,
        firstNameRegexError: false,
        firstNameErrorLog: '限中文',

        lastNameError: false,
        lastNameRegexError: false,
        lastNameErrorLog: '限中文',

        genderError: false,
        publicError: false,
        professionError: false,
        characterError: false,
      },
      checkEmptyAllPass: true,
    };
  },

  created() {
    if (!this.loginStatus) {
      this.$router.push({
        name: 'index',
      }).catch(() => true);
    }
  },

  mounted() {
    this.accountProfile = {
      user_type: this.loginProfile.user_type,
      gender: this.loginProfile.gender,
      public: this.loginProfile.public,
      thumbSrc: this.loginProfile.thumbSrc,
      firstName: this.loginProfile.firstName,
      lastName: this.loginProfile.lastName,
      account: this.loginProfile.oauth,
      email: this.loginProfile.email,
      verified: this.loginProfile.verified,
      profession: this.loginProfile.profession,
      hospital: this.loginProfile.hospital,
      character: this.loginProfile.character,
      introduction: this.loginProfile.introduction,
    };

    this.avatarShowName = `${this.loginProfile.firstName}${this.loginProfile.lastName}`;
    this.isPreloading = false;
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changeAuthJwtToken: 'user/USER_AUTH_JWT',
      // changeUpdateKey: 'global/FORCE_UPDATE_KEY',
    }),

    ...mapActions({
      changeLoginStatus: 'user/userLoginMember',
      changeUserPanel: 'user/changeTopBarUserPanelFocus',
    }),

    sendFindPassword() {
      this.changePopBoxStatus({
        active: true,
        include: 'forgetPassword',
      });
    },

    sendVerifiedEmail() {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;

      this.changePopBoxStatus({
        active: true,
        include: 'sendVerify',
      });

      // getSendVerifiedMail(`?mail=${this.accountProfile.email}`, {
      //   headers: {
      //     'content-Type': 'application/json',
      //     // Authorization: `Bearer ${jwtAccess}`,
      //   },
      // })
      //   .then((/* response */) => {
      //     // console.log(response.data.results);
      //   })
      //   .catch((error) => {
      //     console.log('Axios getSendVerifiedMail Error', error.response);
      //     if (error.response.status === 401) {
      //       this.changePopBoxStatus({
      //         active: true,
      //         include: 'relogin',
      //       });
      //     }
      //   });
      // this.changePopBoxStatus({
      //   active: true,
      //   include: 'sendVerified',
      // });
      // setTimeout(() => {
      //   // 關閉 POPBOX
      //   this.changePopBoxStatus({
      //     active: false,
      //     include: '',
      //   });
      // }, this.POP_DURATION);
    },

    showAvatarUploader() {
      this.changePopBoxStatus({
        active: true,
        include: 'avatarUpload',
      });
    },

    setGenderSelectValue(value) {
      // eslint-disable-next-line no-unused-expressions
      value === '先生' ? this.accountProfile.gender = '0' : this.accountProfile.gender = '1';
    },

    setCharacterSelectValue(value) {
      // eslint-disable-next-line no-unused-expressions
      this.accountProfile.character = value;
    },

    setPublicSelectValue(value) {
      // eslint-disable-next-line no-unused-expressions
      value === '公開' ? this.accountProfile.public = 'yes' : this.accountProfile.public = '';
    },

    setProfessionSelectValue(value) {
      if (value === '填寫其他') {
        this.otherProfessionShow = true;
        this.accountProfile.profession = '';
      } else {
        this.otherProfessionShow = false;
        this.accountProfile.profession = value;
      }
    },

    handleFormsCheckToPass() {
      return new Promise((resolve) => {
        this.checkEmptyAllPass = this.$options.data().checkEmptyAllPass;

        const emailPattern = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        const phonePattern = new RegExp(/^09\d{8}$/);
        // 姓氏與姓名不是中文
        const chinesePattern = new RegExp(/[\u4e00-\u9fa5]$/);

        if (this.loginProfile.account_login === 'cancell') {
          if (this.accountProfile.account) {
            if (this.accountProfile.account.match(emailPattern)) {
              // (Auth Step-1) 檢查Email是否已被註冊
              this.accountType = 'email';
              this.accountProfile.email = this.accountProfile.account;
  
              if (this.accountProfile.account !== this.loginProfile.oauth && this.isAccountChange) {
                getDjangoAllTypeMember(`?oauth=${this.accountProfile.account}`)
                  .then((response) => {
                    if (response.data.count) {
                      this.checkEmptyStatus.accountRegexError = true;
                      this.checkEmptyStatus.accountError = true;
                      this.checkEmptyStatus.accountErrorLog = '抱歉，信箱已被註冊';
                      this.checkEmptyAllPass = false;
                    }
                  })
                  .catch((error) => {
                    console.log('Axios getDjangoAllTypeMember Error', error.response);
                  });
              }
  
            } else if (this.accountProfile.account.match(phonePattern)) {
              // (Auth Step-1) 檢查Email是否已被註冊
              this.accountType = 'phone';
  
              if (this.accountProfile.account !== this.loginProfile.oauth) {
                getDjangoAllTypeMember(`?oauth=${this.accountProfile.account}`)
                  .then((response) => {
                    if (response.data.count) {
                      this.checkEmptyStatus.accountRegexError = true;
                      this.checkEmptyStatus.accountError = true;
                      this.checkEmptyStatus.accountErrorLog = '抱歉，手機已被註冊';
                      this.checkEmptyAllPass = false;
                    }
                  })
                  .catch((error) => {
                    console.log('Axios getDjangoAllTypeMember Error', error.response);
                  });
              }

              if (this.accountProfile.email && this.accountProfile.email !== this.loginProfile.email) {
                if (this.accountProfile.email.match(emailPattern)) {
                  getDjangoAllTypeMember(`?oauth=${this.accountProfile.email}`)
                    .then((response) => {
                      if (response.data.count) {
                        this.checkEmptyStatus.emailRegexError = true;
                        this.checkEmptyStatus.emailError = true;
                        this.checkEmptyStatus.emailErrorLog = '抱歉，信箱已被註冊';
                        this.checkEmptyAllPass = false;
                      }
                    })
                    .catch((error) => {
                      console.log('Axios getDjangoAllTypeMember Error', error.response);
                    });
                } else {
                  this.checkEmptyStatus.emailRegexError = true;
                  this.checkEmptyStatus.emailError = true;
                  this.checkEmptyStatus.emailErrorLog = '格式錯誤(範例: mail@gmail.com)';
                  this.checkEmptyAllPass = false;
                }
              }
            } else {
              this.checkEmptyStatus.accountRegexError = true;
              this.checkEmptyStatus.accountError = true;
              this.checkEmptyStatus.accountErrorLog = '格式錯誤(範例: 0912345678、mail@gmail.com)';
              this.checkEmptyAllPass = false;
            }
          } else {
            this.checkEmptyStatus.accountError = true;
            this.checkEmptyAllPass = false;
          }
        }

        // 驗證性別欄位
        if (this.accountProfile.gender === '') {
          this.checkEmptyStatus.genderError = true;
          this.checkEmptyAllPass = false;
        }

        // 驗證姓氏欄位為空
        if (this.accountProfile.firstName) {
          if (!this.accountProfile.firstName.match(chinesePattern)) {
            // console.log('偵測不是中文!!');
            this.checkEmptyStatus.firstNameError = true;
            this.checkEmptyStatus.firstNameRegexError = true;
            this.checkEmptyAllPass = false;
          }
        } else {
          this.checkEmptyStatus.firstNameError = true;
          this.checkEmptyAllPass = false;
        }
        // 驗證名字欄位為空
        if (this.accountProfile.lastName) {
          if (!this.accountProfile.lastName.match(chinesePattern)) {
            // console.log('偵測不是中文!!');
            this.checkEmptyStatus.lastNameError = true;
            this.checkEmptyStatus.lastNameRegexError = true;
            this.checkEmptyAllPass = false;
          }
        } else {
          this.checkEmptyStatus.lastNameError = true;
          this.checkEmptyAllPass = false;
        }
        // 驗證醫護會員 主治癌症欄位
        // if (this.accountProfile.user_type === 'doctor') {
        //   if (this.accountProfile.profession === '') {
        //     this.checkEmptyStatus.professionError = true;
        //     this.checkEmptyAllPass = false;
        //   }
        // }

        // 驗證身份欄位
        if (this.accountProfile.user_type === 'doctor') {
          if (this.accountProfile.character === '') {
            this.checkEmptyStatus.characterError = true;
            this.checkEmptyAllPass = false;
          }
        }

        // 傳送檢查結果
        setTimeout(() => {
          return resolve({
            usertype: this.accountProfile.user_type,
            checkStatus: this.checkEmptyAllPass,
          });
        }, 600);
      });
    },

    processAfterUpdateConfirm() {
      this.changePopBoxStatus({
        active: true,
        include: 'updateConfirm',
      });

      this.UPDATE_ROUTE += 1;

      setTimeout(() => {
        // 關閉 POPBOX
        this.changePopBoxStatus({
          active: false,
          include: '',
        });

        // this.$router.go(this.$router.currentRoute);

        // 更新User Store State 成已訂閱
        GlobalEmitter.emit('force-root-update', {
          event: 'userProfile-refresh',
        });
      }, this.POP_DURATION);
    },

    updateAccountProfile(passValue) {
      if (!passValue.checkStatus) { return; }

      let PUT_DATA;

      switch (passValue.usertype) {
        case 'doctor':
          PUT_DATA = {
            user_type: this.accountProfile.user_type,
            gender: this.accountProfile.gender,
            // thumbSrc: this.accountProfile.thumbSrc || '',
            firstName: this.accountProfile.firstName,
            lastName: this.accountProfile.lastName,
            oauth: this.accountProfile.account,
            phone: this.accountType === 'phone' ? this.accountProfile.account : '',
            email: this.accountType === 'email' ? this.accountProfile.account : this.accountProfile.email,
            profession: this.accountProfile.profession,
            hospital: this.accountProfile.hospital,
            character: this.accountProfile.character,
            introduction: this.accountProfile.introduction,
          };

          if (!this.isAccountChange) {
            delete PUT_DATA['oauth'];

            putUniqueDoctor(`/${this.loginHashCode}`, PUT_DATA)
              .then((res) => { this.processAfterUpdateConfirm(); })
              .catch((error) => { console.log('一般個人資料頁，更新失敗', error.response); });
          } else {
            axios.all([
              putUniqueDoctor(`/${this.loginHashCode}`, PUT_DATA),
              putEditUserAccount(`/?hashcode=${this.loginHashCode}`, {
                auth_id: `${this.loginDjangoId}`,
                oauth: PUT_DATA.oauth,
                phone: PUT_DATA.phone,
                email: PUT_DATA.email,
              }, {
                headers: {
                  'content-Type': 'application/json',
                  // Authorization: `Bearer ${jwtAccess}`,
                }})])
              .then(axios.spread((data1, data2) => {
                // this.processAfterUpdateConfirm();
                localStorage.removeItem('cc-jwt');
                this.processAfterUpdateAccountConfirmAndLogOut();
              }))
              .catch((error) => { console.log('一般個人資料頁，更新失敗', error.response); })
          }
          break;

        case 'normal':
          PUT_DATA = {
            public: this.accountProfile.public,
            user_type: this.accountProfile.user_type,
            gender: this.accountProfile.gender,
            // thumbSrc: this.accountProfile.thumbSrc || '',
            firstName: this.accountProfile.firstName,
            lastName: this.accountProfile.lastName,
            oauth: this.accountProfile.account,
            phone: this.accountType === 'phone' ? this.accountProfile.account : '',
            email: this.accountType === 'email' ? this.accountProfile.account : this.accountProfile.email,
          };

          if (!this.isAccountChange) {
            delete PUT_DATA['oauth'];
            if (this.loginProfile.account_login === 'line') {
              delete PUT_DATA['phone'];
            }

            putUniqueNormal(`/${this.loginHashCode}`, PUT_DATA)
              .then((res) => { this.processAfterUpdateConfirm(); })
              .catch((err) => { console.log('一般個人資料頁，更新失敗', err.response); });
          } else {
            if (this.loginProfile.account_login === 'line') {
              delete PUT_DATA['phone'];
            }
            axios.all([
              putUniqueNormal(`/${this.loginHashCode}`, PUT_DATA),
              putEditUserAccount(`/?hashcode=${this.loginHashCode}`, {
                auth_id: `${this.loginDjangoId}`,
                oauth: PUT_DATA.oauth,
                phone: PUT_DATA.phone,
                email: PUT_DATA.email,
              }, {
                headers: {
                  'content-Type': 'application/json',
                  // Authorization: `Bearer ${jwtAccess}`,
                }})])
              .then(axios.spread((data1, data2) => {
                localStorage.removeItem('cc-jwt');
                this.processAfterUpdateAccountConfirmAndLogOut();
              }))
              .catch((err) => {
                console.log('一般個人資料頁，更新失敗', err.response);
              });
          }
          break;

        default:
          break;
      }
    },

    processAfterUpdateAccountConfirmAndLogOut() {
      deleteSessionKeepLogin(`/${this.loginHashCode}`)
        .then((/* response */) => {
          console.log('成功登出，並移除Session');
          localStorage.removeItem('cc-jwt');

          this.changePopBoxStatus({
            active: true,
            include: 'updateConfirm',
          });

          this.UPDATE_ROUTE += 1;

          const logOutProcess = new Promise((resolve) => {
            this.changeAuthJwtToken(null);
            // this.changeUserPanel(false);
            return resolve('done');
          });

          logOutProcess.then((value) => {
            if (value === 'done') {
              setTimeout(() => {
                this.$router.replace({
                  name: 'index',
                }).catch(()=>{});

                this.changeLoginStatus({
                  isLogin: false,
                  djangoId: null,
                  hashCode: '',
                  profile: {},
                });

                this.changePopBoxStatus({
                  active: true,
                  include: 'login',
                });
              }, this.POP_DURATION);
            }
          });
        })
        .catch((/* error */) => {
          console.log('移除Session 出包!');
          this.changePopBoxStatus({
            active: false,
            include: '',
          });
        });

      // setTimeout(() => {
      //   // 關閉 POPBOX
      //   this.changePopBoxStatus({
      //     active: false,
      //     include: 'login',
      //   });

      //   // this.$router.go(this.$router.currentRoute);
      // }, this.POP_DURATION);
    },

    startCheckAndUpdateProcess() {
      this.handleFormsCheckToPass().then(this.updateAccountProfile);
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      authJwtToken: 'user/exportUserJwtToken',
      loginDjangoId: 'user/exportUserDjangoId',
      loginHashCode: 'user/exportUserHashCode',
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
      // forceUpdateKey: 'global/exportForceUpdateKey',
      subscribeVip: 'user/exportUserSubscribeVip',
      loginSubscribeValid: 'user/exportUserSubscribeValid',
    }),
  },

  watch: {
    'accountProfile.account': function (val) {
      if (val !== this.loginProfile.oauth) {
        this.isAccountChange = true;
      }
    },
  }
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/account/setting.scss';
</style>
